export enum EnumTipoPeriodicidad {
  Variable = 1,
  Diario,
  Semanal,
  Quincenal,
  Mensual,
  Bimensual,
  // Trimestral,
  Semestral = 8,
  Anual = 9
}
